export default __webpack_public_path__ + "static/media/ef.png";